import gsap from 'gsap';

const SlideFadeIn = (element) => {
  const tl = gsap.timeline();
  tl.to(element, {
    y: 0,
    autoAlpha: 1,
    ease: 'expo.out',
    duration: 1.2,
  });
};

export default SlideFadeIn;
